<kb-hero-carousel [pages]="pages"></kb-hero-carousel>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
